import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
})
export class TableComponent {
  @Input() cols: {
    field: string;
    header: string;
    pipe?: string;
    disableClick?: boolean;
  }[] = [];
  @Input() data: any[] = [];
  @Input() tableStyle: any = { 'min-width': '50rem' };
  @Output() sendClick = new EventEmitter();
  @Input() showCustomHeader: boolean = false;
  @Input() customHeader: string = '';

  ngOnInit(){
  }

  onLinkClick(id: number) {
    this.sendClick.emit(id);
  }

  onRecordUpdate(id: number, buttonType: any) {
    this.sendClick.emit({id, buttonType})
  }

}
